module.exports = __webpack_public_path__ + "img/pipe-4.8f0c87d4.jpg";